import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAMap from 'vue-amap';
import '@/css/newfont.css'
import dataV from '@jiaminghi/data-view'
import VueLazyload from 'vue-lazyload'
import EasySlider from "vue-easy-slider";
import VueTouch from "vue-touch"
Vue.use(EasySlider);
Vue.use(VueLazyload)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;

// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnPressEscape.default = false
Vue.use(ElementUI);

Vue.use(dataV);
Vue.use(VueTouch, {name: 'v-touch'})

Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德key
  key: '0337e14a276e4cea5839ada9972a1f67',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation', "AMap.Heatmap"],
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
